// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fold-button[data-v-10d6441e]{border-radius:10px;background-color:#f4f4f5;display:flex;justify-content:center;align-items:center;outline:none;border:none;transition:all .3s}.fold-button[data-v-10d6441e]:hover{background-color:#e9e9eb}.fold-button-x[data-v-10d6441e]{width:16px;height:100%}.fold-button-y[data-v-10d6441e]{height:16px;width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
